import { MenuItem, Select } from "@material-ui/core";
import { StyledInputLabel } from "Components/Shared/StyledComponents";
import { FieldErrorProps, useFieldError } from "Hooks/useFieldError";
import React from "react";
import styled from "styled-components";

type Props = {
  label: string;
  onChange: (event: any) => void;
  className?: string;
  value: any;
  options: DropdownOption[];
} & FieldErrorProps;

export type DropdownOption = {
  value: any;
  text: string;
};

const StyledWrapper = styled.div`
  .ibis-MuiInputBase-root {
    width: 100%;
    .ibis-MuiSelect-root {
      padding: 10px 12px;
    }
  }
`;

export const Dropdown: React.FunctionComponent<Props> = props => {
  const { hasError } = useFieldError(props);

  return (
    <StyledWrapper className={props.className}>
      <StyledInputLabel hasError={hasError} className={"form-label"}>
        {props.label}
      </StyledInputLabel>
      <Select
        variant={"outlined"}
        value={props.value}
        onChange={props.onChange}
      >
        {props.options.map(e => (
          <MenuItem key={e.value} value={e.value}>
            {e.text}
          </MenuItem>
        ))}
      </Select>
    </StyledWrapper>
  );
};
